import React from 'react'

import BaseConsultsList from 'ui/views/consults/BaseConsultsList'
import analysisStatusConstants from 'utils/constants/analysisStatus'
import serviceStatusConstants from 'utils/constants/serviceStatus'

export default function ({ location }) {
  const title = 'Com Erro'
  const subtitle = 'Consultas que deram erro'
  const status = serviceStatusConstants.SERVICE_STATUS.error
  const color = '#ddd'
  const showBtnReprocessServicesWithError = true

  const arrayAnalysisStatus = [
    analysisStatusConstants.SERVICE_ANALYSIS_STATUS_MOVE_TO.approved,
    analysisStatusConstants.SERVICE_ANALYSIS_STATUS_MOVE_TO.in_attention,
    analysisStatusConstants.SERVICE_ANALYSIS_STATUS_MOVE_TO.reproved,
    analysisStatusConstants.SERVICE_ANALYSIS_STATUS_MOVE_TO.blacklist,
  ]

  return (
    <BaseConsultsList
      location={location}
      title={title}
      subtitle={subtitle}
      color={color}
      actionsAnalysisStatus={arrayAnalysisStatus}
      status={status}
      showBtnReprocessServicesWithError={showBtnReprocessServicesWithError}
    />
  )
}
